import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { decodeBase64 } from "../../util/functions/UniversalFunctions";
import { JSX } from "react";
import AddClasses from "../modal/AddClasses";
import ScheduleMessage from "../modal/ScheduleMessage";
import MedicalFields from "../modal/MedicalFields";
import AddEscort from "../modal/AddEscort";
import AddTeachersToGroup from "../modal/AddTeachersToGroup";
import LogoutModal from "../modal/LogoutModal";
import AssignTeachersToClass from "../modal/AssignTeacherToClass";
import AddStudentToClass from "../modal/AddStudentToClass";
import AttendanceReportYearly from "../modal/AttendanceReportYearly";
import AttendanceReportMonthly from "../modal/AttendanceReportMonthly";
import AttendanceReportByDate from "../modal/AttendanceReportByDate";
import AssignSubject from "../modal/AddSubjectToClass";
import SelectClass from "../modal/SelectClassModel";
import SelectPtmDateAndTime from "../modal/SelectPtmDateAndTime";
import AssignEnquieyModel from "../modal/AssignEnquiryModel";
import QueriesStatus from "../modal/QueriesStatus";
import AddRecipient from "../modal/AddRecipients";
import ConfirmationModal from "../modal/ConfirmationModal";
import CreateInvoice from "../modal/CreateInvoice";
import CreateTemplate from "../modal/CreateTemplate";
import AdmissionStatus from "../modal/AdmissionStatus";
import StaffAttendanceReportYearly from "../modal/StaffAttendanceReportYearly";
import DownloadStaffAttendanceReport from "../modal/DownloadStaffAttendanceReport";
import StaffAttendanceReportDateWise from "../modal/StaffAttendanceReportDateWise";
import CreateEvent from "../modal/CreateEvent";
import ForgottenPassword from "../modal/ForgottenPassword";
import UpdatePassword from "../modal/UpdatePassword";

export default function PopupHandlerLayout() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const popupState = location.state;

  // Close handler — removes popup from URL
  const handleClose = () => {
    navigate(-1);
  };

  // Example: If the URL is ?popup=true&type=info
  const pupupParamEncoded = searchParams.get("popup");
  const pupupParam = decodeBase64(pupupParamEncoded || "");
  const popupsMap: { [key: string]: JSX.Element | null } = {
    addClasses: <AddClasses onClose={handleClose} />,
    scheduleMessage: <ScheduleMessage onClose={handleClose} />,
    medicalFields: <MedicalFields onClose={handleClose} />,
    addEscort: <AddEscort onClose={handleClose} />,
    addTeacher: <AddTeachersToGroup onClose={handleClose} />,
    logout: <LogoutModal onClose={handleClose} />,
    assignTeacherToClass: <AssignTeachersToClass onClose={handleClose} />,
    addStudentToClass: <AddStudentToClass onClose={handleClose} />,
    yearlyReport: <AttendanceReportYearly onClose={handleClose} />,
    monthlyReport: <AttendanceReportMonthly onClose={handleClose} />,
    byDate: <AttendanceReportByDate onClose={handleClose} />,
    assignSubjects: <AssignSubject onClose={handleClose} />,
    confirmation: <ConfirmationModal onClose={handleClose} />,
    selectClass: <SelectClass onClose={handleClose} />,
    selectPtmDateTime: <SelectPtmDateAndTime onClose={handleClose} />,
    assignTo: <AssignEnquieyModel onClose={handleClose} />,
    queriesStatus: <QueriesStatus onClose={handleClose} />,
    addRecipient: <AddRecipient onClose={handleClose} />,
    newInvoice: <CreateInvoice onClose={handleClose} />,
    createTemplate: <CreateTemplate onClose={handleClose} />,
    admissionStatus: (
      <AdmissionStatus
        onClose={handleClose}
        admissionId={popupState?.admissionId}
      />
    ),
    staffAttendance: <StaffAttendanceReportYearly />,
    downloadStaffAttendanceReport: <DownloadStaffAttendanceReport />,
    staffAttendanceDateWise: <StaffAttendanceReportDateWise />,
    createEvent: <CreateEvent onClose={handleClose} />,
    forgotenPassword: <ForgottenPassword onClose={handleClose} />,
    updatePassword: <UpdatePassword onClose={handleClose} />,
  };

  // console.log(searchParams);

  return <>{popupsMap[pupupParam]}</>;
}
